import tabComp from './tabComp.vue';
import pagination from './pagtion.vue';
// 全局注册组件
export default {
    install(Vue){
        Vue.component('tabComp',tabComp);
        Vue.component('pagination',pagination)
    }
}